import { Dataset, DatasetDTO } from "../../types/Dataset";
import { FieldDTO } from "../../types/Field";

// In data explorer we only want to edit/manage the fields that are directly related to our domain.
export const filterConcreteFields = <T extends DatasetDTO>(domainDataset: T): T => {
  const domainFields = domainDataset.fields.filter(
    (field) => field.datasetId === domainDataset.id,
  );
  return {
    ...domainDataset,
    fields: domainFields,
  };
};

/* isFieldHidden & isDatasetHidden & isDomainHidden determine whether the Field/Dataset/Domain is visually dimmed in the Side panel */
export function isFieldHidden(field: FieldDTO): boolean {
  return field.visible === false && field.aiVisible === false;
}

export function isDatasetHidden(dataset: DatasetDTO): boolean {
  return dataset.visible === false && dataset.aiVisible === false;
}

export function isDomainHidden(dataset: Dataset): boolean {
  return dataset.mappingStatus !== "VALID" || isDatasetHidden(dataset);
}

/* sortDTOByKeys is a utility function to sort DTOs by specific keys, with optional hidden item handling, used primarily in Side panel*/
export function sortDTOByKeys<T>(keys: (keyof T)[], isHidden?: (item: T) => boolean) {
  return (a: T, b: T) => {
    if (isHidden) {
      const aHidden = isHidden(a);
      const bHidden = isHidden(b);
      if (!aHidden && bHidden) return -1;
      if (aHidden && !bHidden) return 1;
    }

    for (const key of keys) {
      const aVal = a[key];
      const bVal = b[key];
      if (typeof aVal === "string" && typeof bVal === "string") {
        const cmp = aVal.localeCompare(bVal, undefined, { sensitivity: "base" });
        if (cmp !== 0) return cmp;
      } else if (aVal !== bVal) {
        // fallback for non-string values
        return aVal < bVal ? -1 : 1;
      }
    }
    return 0;
  };
}
